const isAllowedModuleAction = {
  install: (app, store) => {
    app.config.globalProperties.$isAllowedModuleAction = (md, ac) => {
      const profile = store.getters['auth/getProfile'];

      // If no profile or porfile.role, return false
      if (!profile || !profile.role) return false;

      // If the user is superadmin, return true
      if (profile.role.name === 'superadmin') {
        return true;
      }

      // test if user has permission to access the module
      if (!profile.role.modules[md.toUpperCase()]) {
        return false;
      }

      // test if user has permission to access the action
      if (!profile.role.modules[md.toUpperCase()].includes(ac.toUpperCase())) {
        return false;
      }

      return true;
    };

    app.provide(
      '$isAllowedModuleAction',
      app.config.globalProperties.$isAllowedModuleAction
    );
  },
};

export default isAllowedModuleAction;
